export enum BillingTypeEnum {
  'FAD' = 'FAD',
  'FCSE' = 'FCSE',
  'MIXTE' = 'MIXTE'
}

export const billingTypeEnumMapping: Record<BillingTypeEnum, string> = {
  [BillingTypeEnum.FAD]: 'Facturation Ayants Droit',
  [BillingTypeEnum.FCSE]: 'Facturation CSE',
  [BillingTypeEnum.MIXTE]: 'Facturation Mixte'
}
